import React from 'react';
import { CommonIconProps } from './Icon';

const ShieldCheckIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.059 0.944789C2.98 0.735789 4.73767 0.500122 8 0.500122C11.2623 0.500122 13.02 0.735789 13.941 0.944789C14.7297 1.12346 15.179 1.78712 15.2627 2.49946C15.4276 3.92598 15.5066 5.36112 15.4993 6.79712C15.481 10.0045 13.7843 13.0031 10.9283 14.5151C10.417 14.7858 9.898 15.0288 9.40833 15.2051C8.92467 15.3795 8.43767 15.5001 8 15.5001C7.56233 15.5001 7.07533 15.3795 6.592 15.2051C6.102 15.0288 5.583 14.7858 5.072 14.5151C2.21533 13.0031 0.518667 10.0045 0.500333 6.79712L0.5 6.60012C0.5 4.85612 0.633667 3.38012 0.737333 2.49946C0.820667 1.78712 1.27067 1.12346 2.059 0.944789ZM12.0487 5.87479C12.2273 5.60012 12.2707 5.24446 12.077 4.98012C11.8387 4.65512 11.537 4.42779 11.2723 4.27446C10.9127 4.06646 10.4817 4.22479 10.2423 4.56446C8.78133 6.63912 7.87167 7.98546 7.87167 7.98546C7.87167 7.98546 7.325 7.30546 6.41533 6.32779C6.1 5.98846 5.58767 5.92012 5.23833 6.22446C5.02733 6.406 4.83422 6.60737 4.66167 6.82579C4.42933 7.12479 4.47833 7.53846 4.71633 7.83312C5.463 8.75629 6.26081 9.63689 7.106 10.4708C7.61 10.9675 8.39933 10.9265 8.84267 10.3748C9.51967 9.53279 10.6043 8.09079 12.0487 5.87479Z"
      fill={color}
    />
  </>
);

export default ShieldCheckIcon;

ShieldCheckIcon.prototype.svgPropOverrides = { viewBox: '0 0 16 16' };
